import { render, staticRenderFns } from "./BatchProcessForm.vue?vue&type=template&id=2b812262&scoped=true&"
import script from "./BatchProcessForm.vue?vue&type=script&lang=js&"
export * from "./BatchProcessForm.vue?vue&type=script&lang=js&"
import style0 from "./BatchProcessForm.vue?vue&type=style&index=0&id=2b812262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b812262",
  null
  
)

export default component.exports